export default {
  plans: [],
  action_plan: {},
  plan_items: [],
};
